import { render, staticRenderFns } from "./AdminAreaSet.vue?vue&type=template&id=20e0b7a8&scoped=true&"
import script from "./AdminAreaSet.vue?vue&type=script&lang=js&"
export * from "./AdminAreaSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e0b7a8",
  null
  
)

export default component.exports